<template>
  <div class="whitespace-normal items-center flex space-x-1">
    <phone-icon class="text-gray-400 dark:text-gray-500 h-6 w-6" />
    <span class="leading-4 text-gray-600 dark:text-gray-400 font-medium text-sm">
      {{ clientGetFormattedPhone(client) }}
    </span>
  </div>
</template>

<script setup>
  import { PhoneIcon } from '@heroicons/vue/solid';

  import { clientGetFormattedPhone } from '../lib';

  defineProps({
    client: {
      type: Object,
      required: true,
    },
  });
</script>
